import { useTranslation } from "react-i18next";
import {
  FactCheckOutlined,
  PersonOutlineOutlined,
  GridViewOutlined,
  QueryStats,
  DevicesOutlined,
  List as ListIcon,
  ContentPaste,
} from "@mui/icons-material";
import { KeyConstant, PathConstant, SystemConstant } from "@/const";
import { SideBarItemType } from "@/types/view";
import { StorageUtils } from "@/utils";

export type SidebarMenuType = SideBarItemType & {
  subItems?: SideBarItemType[];
};

const useMenuSidebar = () => {
  const role = StorageUtils.getItem<string>(KeyConstant.KEY_ROLE);
  const { t: getLabel } = useTranslation();

  const menuList: SidebarMenuType[] = [
    {
      key: "requestManagement",
      title: getLabel("OBJ_MENU_PAGE.requestManagement"),
      icon: <QueryStats fontSize="small" />,
      url: "",
      subItems: [
        {
          key: "internalRequestList",
          title: getLabel("OBJ_MENU_PAGE.internalRequestList"),
          url: PathConstant.MN_REQUEST,
          icon: <ListIcon fontSize="small" />,
        },
        {
          key: "externalRequestList",
          title: getLabel("OBJ_MENU_PAGE.externalRequestList"),
          url: PathConstant.MN_RESPONSE,
          icon: <FactCheckOutlined fontSize="small" />,
        },
      ],
    },
    {
      key: "searchManagement",
      title: getLabel("OBJ_MENU_PAGE.searchManagement"),
      icon: <QueryStats fontSize="small" />,
      url: "",
      subItems: [
        {
          key: "identitySearchList",
          title: getLabel("OBJ_MENU_PAGE.identitySearchList"),
          url: PathConstant.MN_ID_SEARCH,
          icon: <ContentPaste fontSize="small" />,
        },
        {
          key: "sailorSearchList",
          title: getLabel("OBJ_MENU_PAGE.sailorSearchList"),
          url: PathConstant.MN_SAILOR_SEARCH,
          icon: <ContentPaste fontSize="small" />,
        },
        {
          key: "shipSearchList",
          title: getLabel("OBJ_MENU_PAGE.shipSearchList"),
          url: PathConstant.MN_SHIP_SEARCH,
          icon: <ContentPaste fontSize="small" />,
        },
      ],
    },
    {
      key: "responseManagement",
      title: getLabel("OBJ_MENU_PAGE.responseManagement"),
      icon: <QueryStats fontSize="small" />,
      url: "",
      subItems: [
        {
          key: "identityResponseList",
          title: getLabel("OBJ_MENU_PAGE.identityResponseList"),
          url: PathConstant.MN_ID_RESPONSE,
          icon: <FactCheckOutlined fontSize="small" />,
        },
        {
          key: "sailorResponseList",
          title: getLabel("OBJ_MENU_PAGE.sailorResponseList"),
          url: PathConstant.MN_SAILOR_RESPONSE,
          icon: <FactCheckOutlined fontSize="small" />,
        },
        {
          key: "violationResponseList",
          title: getLabel("OBJ_MENU_PAGE.violationResponseList"),
          url: PathConstant.MN_VIOLATION_RESPONSE,
          icon: <FactCheckOutlined fontSize="small" />,
        },
      ],
    },
    {
      key: "userManagement",
      title: getLabel("OBJ_MENU_PAGE.userManagement"),
      url: PathConstant.MN_USER,
      isHide: !Boolean(role && parseInt(role) === SystemConstant.ROLE.admin),
      icon: <PersonOutlineOutlined fontSize="small" />,
    },
    {
      key: "appManagement",
      title: getLabel("OBJ_MENU_PAGE.appManagement"),
      url: PathConstant.MN_APPLICATION,
      icon: <GridViewOutlined fontSize="small" />,
    },
    {
      key: "deviceManagement",
      title: getLabel("OBJ_MENU_PAGE.deviceManagement"),
      url: PathConstant.MN_DEVICE,
      icon: <DevicesOutlined fontSize="small" />,
    },
  ];

  return {
    menuList: menuList
      .map(menu => {
        if (menu.subItems) {
          menu.subItems = menu.subItems.filter(item => !Boolean(item.isHide));
          return menu;
        }
        return menu;
      })
      .filter(menu => !Boolean(menu.isHide)),
  };
};

export default useMenuSidebar;
